import React from "react";
import { DataGrid, esES } from "@mui/x-data-grid";
import SnackbarAlert from "./SnackbarAlert";
import useToken from "../useToken";
import { Tooltip } from "@mui/material";
import GetAppIcon from "@material-ui/icons/GetApp";
import { inventarioResources } from "../endpoints";
import LinearProgress from "@mui/material/LinearProgress";

class TablaPanelAuditorias extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: useToken.getUser(),
      openSnack: false,
      message: null,
      severity: null,
      selectedRow: null,
      pageSize: 25
    };
  }

  getArchivoResultado = (rowData) => {
    
        let schema = "inv_" + rowData.folio;
    
        inventarioResources
          .getRutaArchivosFinales(rowData.folio)
          .then(async (response) => await response.json())
          .then((data) => {
    
            if (data.length > 0) {
    
              const link = document.createElement("a");
              let ruta = `/spool/${schema}/exportaciones/${data[0]}`;
    
              link.href = `/static${ruta}`;
    
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
    
            } else {
                  this.setState({
                    openSnack:false
                    },()=>{
                    this.setState({
                        openSnack: true,
                        severity: "error",
                        message: "No hay archivos para descargar"
                    });
                })
            }
          });
      };


  render() {
    const columns = [
      { field: "centro", headerName: "Centro", flex: 1, minWidth: 100, },
      { field: "folio", headerName: "Folio", flex: 1, minWidth: 100, },
      {
        field: "fecha",
        headerName: "Fecha",
        flex: 1,
        minWidth: 110,
      },
      {
        field: "total_cajas",
        headerName: "Total Cajas",
        flex: 1,
        minWidth: 100,
        type: "number",
        valueFormatter: (params) =>
          new Intl.NumberFormat("de-DE").format(params.value)
      },
      {
        field: "total_cajas_error",
        headerName: "Cajas Error",
        flex: 1,
        minWidth: 100,
        type: "number",
        valueFormatter: (params) =>
          new Intl.NumberFormat("de-DE").format(params.value)
      },
      {
        field: "p_error_cajas",
        headerName: "Error Cajas (%)",
        flex: 1,
        minWidth: 120,
        renderCell: (params) => {
          if (params.value == null) return null;

          const valueNum = params.value; 
          const valueStr = `${valueNum}%`; 

          let color = "success"; 
          if (valueNum >= 5) color = "error";

          return (
            <div style={{ width: "100%" }}>
              <div style={{ fontSize: 12, fontWeight: 600 }}>
                {valueStr}
              </div>

              <LinearProgress
                variant="determinate"
                value={valueNum}
                color={color}
                sx={{
                  height: 8,
                  borderRadius: 4
                }}
              />
            </div>
          );
        }
      },
      {
        field: "total_cantidad_caja",
        headerName: "Total Un.",
        flex: 1,
        minWidth: 100,
        type: "number",
        valueFormatter: (params) =>
          new Intl.NumberFormat("de-DE").format(params.value)
      },
      {
        field: "dif_cantidad",
        headerName: "Error Un.",
        flex: 1,
        minWidth: 100,
        type: "number",
        valueFormatter: (params) =>
          new Intl.NumberFormat("de-DE").format(params.value)
      },
      {
        field: "p_error_unidades",
        headerName: "Error Un.(%)",
        flex: 1,
        minWidth: 120,
        renderCell: (params) => {
          if (params.value == null) return null;

          const valueNum = params.value; 
          const valueStr = `${valueNum}%`; 

          let color = "success"; 
          if (valueNum >= 5) color = "error";

          return (
            <div style={{ width: "100%" }}>
              <div style={{ fontSize: 12, fontWeight: 600 }}>
                {valueStr}
              </div>

              <LinearProgress
                variant="determinate"
                value={valueNum}
                color={color}
                sx={{
                  height: 8,
                  borderRadius: 4
                }}
              />
            </div>
          );
        }
      },
      {
        field: "total_monto_caja",
        headerName: "Total Monto",
        flex: 1,
        minWidth: 130,
        type: "number",
        valueFormatter: (params) =>
          new Intl.NumberFormat("de-DE").format(params.value)
      },
      {
        field: "dif_monto",
        headerName: "Error Monto",
        flex: 1,
        minWidth: 130,
        type: "number",
        valueFormatter: (params) =>
          new Intl.NumberFormat("de-DE").format(params.value)
      },
      {
        field: "p_error_monto",
        headerName: "Error Monto (%)",
        flex: 1,
        minWidth: 130,
        renderCell: (params) => {
          if (params.value == null) return null;

          const valueNum = params.value; 
          const valueStr = `${valueNum}%`; 

          let color = "success"; 
          if (valueNum >= 5) color = "error";

          return (
            <div style={{ width: "100%" }}>
              <div style={{ fontSize: 12, fontWeight: 600 }}>
                {valueStr}
              </div>

              <LinearProgress
                variant="determinate"
                value={valueNum}
                color={color}
                sx={{
                  height: 8,
                  borderRadius: 4
                }}
              />
            </div>
          );
        }
      },
      {
        field: "acciones",
        headerName: "Acciones",
        minWidth: 100,
        flex: 1,
        sortable: false,
        renderCell: (params) => {

        const rowData = params.row;

        return (

            <div style={{ display: "flex", gap: 8 }}>
            
            <Tooltip title="Descargar archivos finales">
                <GetAppIcon
                    style={{ cursor: "pointer" }}
                    onClick={() => this.getArchivoResultado(rowData)}
                />
            </Tooltip>

            </div>

        );
        }
      }
    ];

    return (
      <div style={{ height: '100%', width: "100%" }}>
        <DataGrid
          rows={this.props.disponibles}
          disableColumnMenu
          localeText={esES.components.MuiDataGrid.defaultProps.localeText}
          columns={columns}
          rowCount={this.props.total ?? 0}
          sortingOrder={['asc', 'desc']}
          sortingMode="server" 
          onSortModelChange={this.props.onSortChange} 
          paginationMode="server"
          paginationModel={this.props.paginationModel}          
          pageSizeOptions={[10, 25, 50]}
          onPaginationModelChange={this.props.onPageChange}
          onRowClick={(params) =>
            this.setState({ selectedRow: params.id })
          }
          getRowClassName={(params) => {
            if (this.state.selectedRow === params.id)
              return "row-selected";
            return "";
          }}
          getRowId={(row) => row.folio}
        />
  
        {this.state.openSnack && (
          <SnackbarAlert
            severity={this.state.severity}
            message={this.state.message}
          />
        )}

        <style>
          {`
            .row-selected { background-color: #dbe9fc !important; }
          `}
        </style>
      </div>
    );
  }
}

export default TablaPanelAuditorias;